import { useLayoutEffect, useState } from 'react';

interface Dimensions {
  width: number;
  height: number;
}

export interface WindowSize {
  window: Dimensions;
  document: Dimensions;
}

export default function useWindowSize (): WindowSize {
  const [size, setSize] = useState<WindowSize>({ window: { width: 0, height: 0 }, document: { width: 0, height: 0 }});
  useLayoutEffect(() => {
    function updateSize () {
      setSize({
        window: { width: window.innerWidth, height: window.innerHeight },
        document: { width: document.documentElement.clientWidth, height: document.documentElement.clientHeight }
      });
    }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return size;
}
